import { useMutation } from "@tanstack/react-query";
import { authClient } from "../auth-client";

export async function signupAnon(captchaToken: string) {
  const { data, error } = await authClient.signIn.anonymous({
    fetchOptions: { headers: { "x-captcha-response": captchaToken } },
  });
  if (error) throw new Error(error.message ?? "Unable to sign in");
  return data;
}

export const useSignupAnon = () => {
  const m = useMutation({
    mutationFn: (token: string) => signupAnon(token),
    mutationKey: ["signupAnon"],
  });
  return { ...m, signupAnon: m.mutateAsync };
};
